import { useEffect, useSyncExternalStore } from 'react';
import { useAuth } from '@workos-inc/authkit-react';
import { listAccessRequests } from '../api/accessRequests';
import { openRequestCount } from '../lib/openRequestCount';

export function useOpenRequestCount(): number | null {
  const auth = useAuth();
  const count = useSyncExternalStore(openRequestCount.subscribe, openRequestCount.get);
  const canRead = (auth.permissions ?? []).includes('org-admin:user-read');

  useEffect(() => {
    if (!canRead || openRequestCount.get() !== null) return;
    const ctrl = new AbortController();
    void (async () => {
      try {
        const token = await auth.getAccessToken();
        if (!token) return;
        const { data } = await listAccessRequests(token, ctrl.signal);
        if (data) openRequestCount.set(data.requests.length);
      } catch { /* the badge stays off until the Requests page is opened */ }
    })();
    return () => ctrl.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one read per mount; the store carries later changes
  }, [canRead]);

  return count;
}
